
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shop]/brands-sitemap",
      function () {
        return require("private-next-pages/[shop]/brands-sitemap.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shop]/brands-sitemap"])
      });
    }
  